import { Typography } from "@chemaxon/design-system/typography";

export const SectionTitle = props => (
  <Typography variant="subtitle1" sx={{ my: 6 }} component="h2" {...props} />
);
